import { render } from "./SubPageHeader.vue?vue&type=template&id=842786a2&scoped=true"
import script from "./SubPageHeader.vue?vue&type=script&lang=js"
export * from "./SubPageHeader.vue?vue&type=script&lang=js"

import "./SubPageHeader.vue?vue&type=style&index=0&id=842786a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-842786a2"]])

export default __exports__